import { useState } from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from '@/components/ui/table';
import { useAuditLog } from '@/lib/queries';
import { useCan } from '@/lib/use-can';
import { formatDate } from '@/lib/utils';

export function AuditLogPage() {
  const can = useCan();
  const [before, setBefore] = useState<string | undefined>(undefined);
  const rows = useAuditLog(before);

  if (!can('settings.audit')) {
    return <p className="text-muted-foreground">You don't have access to this page.</p>;
  }

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Audit log</h1>
        <p className="text-muted-foreground">Admin-triggered changes</p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>{rows.data?.length ?? 0} entries</CardTitle>
        </CardHeader>
        <CardContent>
          <Table>
            <TableHeader>
              <TableRow>
                <TableHead>When</TableHead>
                <TableHead>Actor</TableHead>
                <TableHead>Action</TableHead>
                <TableHead>Target</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody>
              {rows.data?.map((r) => (
                <TableRow key={r.id}>
                  <TableCell className="text-xs text-muted-foreground">
                    {formatDate(r.createdAt)}
                  </TableCell>
                  <TableCell className="font-mono text-xs">{r.actorDiscordId}</TableCell>
                  <TableCell className="font-medium">{r.action}</TableCell>
                  <TableCell className="font-mono text-xs">{JSON.stringify(r.target)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
          {rows.data && rows.data.length === 100 && (
            <div className="mt-4">
              <Button
                variant="outline"
                size="sm"
                onClick={() => setBefore(rows.data![rows.data!.length - 1]!.id)}
              >
                Older
              </Button>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
